/** Create-only seeding guard for the attribution toggles (DC-20, AC-022, AC-061). Pure. */
export interface SeedGuardInput {
  open: boolean;
  mode: 'create' | 'edit';
  hasTemplate: boolean;
  settingsLoaded: boolean;
  seeded: boolean;
  touched: boolean;
}

export function decideSeed(input: SeedGuardInput): boolean {
  return input.open
    && input.mode === 'create'
    && !input.hasTemplate
    && input.settingsLoaded
    && !input.seeded
    && !input.touched;
}
